import { Table, Row, Col } from 'components/AlertTable/styles'
import { formatToLocale } from 'utils/numberFormatter'
import { Row as GRow, Col as GCol } from 'components/Grid'
import React, { Fragment } from 'react'
import classNames from 'classnames'
import './index.css'

const renderRow = ({ key, price: { values }, area, totalArea, doc_count }) => (
  <Row key={`${key}${doc_count}`}>
    <Col width="25%" label="Localização">
      {key}
    </Col>
    <Col width="25%" label="Número de Imóveis">
      {doc_count}
    </Col>
    <Col width="25%" label="Valor médio (R$/m²)">
      {formatToLocale(
        values['50.0'] / (area.values['50.0'] || totalArea.values['50.0']),
        2,
        2,
      )}
    </Col>
    <Col width="25%" label="Valor médio (R$)">
      {formatToLocale(values['50.0'], 2, 2)}
    </Col>
  </Row>
)

const Statistics = ({
  adsNeighborhoodStatistics = [],
  valuatedNeighborhoodStatistics = [],
  active,
  close,
}) => {
  const classes = classNames('Statistics', {
    'Statistics--active': active,
  })
  return (
    <div className={classes}>
      <GRow end="xs">
        <GCol xs={12}>
          <i onClick={close} className="material-icons">
            close
          </i>
        </GCol>
      </GRow>
      {adsNeighborhoodStatistics.length > 0 && (
        <Fragment>
          <GRow>
            <GCol xs={12}>
              <h1 className="Statistics__Header">Estatísticas (Anúncios)</h1>
            </GCol>
          </GRow>
          <Table>
            <Row header>
              <Col header width="25%">
                Localização
              </Col>
              <Col header width="25%">
                Número de Imóveis
              </Col>
              <Col header width="25%">
                Valor médio (R$/m²)
              </Col>
              <Col header width="25%">
                Valor médio (R$)
              </Col>
            </Row>
            {adsNeighborhoodStatistics.map(item => renderRow(item))}
          </Table>
          <br />
        </Fragment>
      )}
      {valuatedNeighborhoodStatistics.length > 0 && (
        <Fragment>
          <GRow>
            <GCol xs={12}>
              <h1 className="Statistics__Header">Estatísticas (Avaliados)</h1>
            </GCol>
          </GRow>
          <Table>
            <Row header>
              <Col header width="25%">
                Localização
              </Col>
              <Col header width="25%">
                Número de Imóveis
              </Col>
              <Col header width="25%">
                Valor médio (R$/m²)
              </Col>
              <Col header width="25%">
                Valor médio (R$)
              </Col>
            </Row>
            {valuatedNeighborhoodStatistics
              .sort((a, b) => a.key - b.key)
              .map(item => renderRow(item))}
          </Table>
        </Fragment>
      )}
    </div>
  )
}

export default Statistics
